import { render, staticRenderFns } from "./EditMaterials.vue?vue&type=template&id=d318ebe6&"
import script from "./EditMaterials.vue?vue&type=script&lang=js&"
export * from "./EditMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports